export const environment = {
	production: true,

	assetsUrl: '',

	baseUrl: 'http://192.168.88.114:1883/',
	HbaseUrl: 'https://bigaunt666.github.io/bigaunt/',

	projectTitleCH: "Big Aunt's | 大阿姨球員卡團拆",

	firebase: {},

	debug: true,
	log: {
		auth: false,
		store: false,
	},

	version: 'v2.0.44',
};
